<template>
  <div class="results-body">
    <div class="results-intro u-light-blue u-bg-primary-light-gradient">
      <div class="container--large">
        <div class="results-intro__title-wrapper">
          <h1 class="results-intro__title u-primary-very-dark u-page-title" v-html="title"></h1>
        </div>
        <div class="results-intro__summary u-primary-very-dark u-sans-serif u-type-20" v-html="summary"></div>

        <div v-if="featured_nodes" :class="featuredNodesClass + ' container--large'">
          <h2 v-if="!isTakeAction && !isEdJusticeTakeAction" :class="featuredNodesClass + '__title u-bg-secondary-dark'">
            {{ featuredNodesTitle }}
          </h2>

          <template v-if="isBills">
            <ul class="featured-bills__list u-border-color-primary-dark" v-html="featured_nodes"></ul>
          </template>
          <template v-else-if="isLettersAndTestimony">
            <ul class="featured-letters__list u-border-color-primary-dark" v-html="featured_nodes"></ul>
          </template>
          <template v-else-if="isTakeAction || isEdJusticeTakeAction">
            <div v-html="featured_nodes"></div>
          </template>
          <template v-else>
            <div class="featured-resources__items u-border-color-primary-dark" v-html="featured_nodes"></div>
          </template>
        </div>

        <filters></filters>
      </div>
    </div>
    <results-meta></results-meta>
    <results-list></results-list>
    <results-pagination @update="query"></results-pagination>
  </div>
</template>

<script>

  const raYear = window.drupalSettings.ra.ra_year
  const typeFilters = window.drupalSettings.searchFilters.type
  const articleTypeFilters = window.drupalSettings.searchFilters.article_type
  const resourceTypeFilters = window.drupalSettings.searchFilters.resource_type
  const campaignFilters = window.drupalSettings.searchFilters.campaign
  const issueFilters = window.drupalSettings.searchFilters.issues
  const professionalPracticeFilters = window.drupalSettings.searchFilters.professional_practice
  const academicSubjectFilters = window.drupalSettings.searchFilters.academic_subject
  const gradeLevelFilters = window.drupalSettings.searchFilters.grade_level
  const roleFilters = window.drupalSettings.searchFilters.role
  const yearFilters = window.drupalSettings.searchFilters.year
  const stateFilters = window.drupalSettings.searchFilters.state
  const neaTodayFilters = window.drupalSettings.searchFilters.nea_today
  const formatFilters = window.drupalSettings.searchFilters.professional_development_format

  const themeFilters = window.drupalSettings.searchFilters.theme
  const readingLevelFilters = window.drupalSettings.searchFilters.reading_level
  const genreFilters = window.drupalSettings.searchFilters.genre

  const actionTypeFilters = window.drupalSettings.searchFilters.action_type
  const congressFilters = window.drupalSettings.searchFilters.congress
  const positionFilters = window.drupalSettings.searchFilters.position
  const chamberFilters = window.drupalSettings.searchFilters.chamber
  const federalDepartmentFilters = window.drupalSettings.searchFilters.federal_department
  const federalCommentsYearFilters = window.drupalSettings.searchFilters.federal_comments_year
  const quickActionFilters = window.drupalSettings.searchFilters.quick_action
  const federalLegislationIssueFilters = window.drupalSettings.searchFilters.federal_legislation_issues

  const neaTodaySectionFilters = window.drupalSettings.searchFilters.nea_today_section

  const featuredNodes = window.drupalSettings.featuredNodes
  const searchSettings = window.drupalSettings.searchSettings
  const engineKey = window.drupalSettings.engineKey

  const {
    ACTIVITY_TID: activityTid,
    ADVICE_TID: adviceTid,
    BOOK_RECOMMENDATION_TID: bookRecommendationTid,
    EDJUSTICE_CAMPAIGN_TID: edjusticeTid,
    EYE_ON_EQUITY_TID: eyeOnEquityTid,
    FEDERAL_COMMENT_TID: federalCommentTid,
    FEDERAL_FUNDING_GUIDE_TID: federalFundingGuideTid,
    PODCAST_TID: podcastTid,
    PROFESSIONAL_DEVELOPMENT_TID: professionalDevelopmentTid,
    REPORT_TID: reportTid,
  } = window.drupalSettings.search.tids

  import Filters from "./Filters";
  import ResultsMeta from "./ResultsMeta";
  import ResultsList from "./ResultsList";
  import ResultsPagination from "./ResultsPagination";
  import {mapGetters} from 'vuex';
  import calendar from '@/mixins/calendar'

  export default {
    name: 'Search',
    mixins: [calendar],
    components: {
      Filters,
      ResultsMeta,
      ResultsList,
      ResultsPagination
    },
    watch: {
      autocompleteTerm: function () {
        if(this.hasKeyword && this.autocompleteTerm !== '' && this.autocompleteTerm.length >= 3) {
          this.autocompleteQuery()
        }
      },
      searchTerm: function () {
        this.$store.commit('updateCurrentPage', 1)
        this.query()
      },
      activeFilters: function () {
        this.query()
      },
    },
    computed: {
      ...mapGetters({
        searchTerm: 'getSearchTerm',
        autocompleteTerm: 'getAutocompleteTerm',
        // searchQuery: 'getQuery',
        currentPage: 'getCurrentPage',
        perPage: 'getPerPage',
        activeFilters: 'getActiveFilters',
        allTypeFilters: 'getAllTypeFilters',
        allGroupOneFilters: 'getAllGroupOneFilters',
        allIssueFilters: 'getAllIssueFilters',
        allRoleFilters: 'getAllRoleFilters',
        allStateFilters: 'getAllStateFilters',
        allCampaignFilters: 'getAllCampaignFilters',
        allArticleTypeFilters: 'getAllArticleTypeFilters',
        allResourceTypeFilters: 'getAllResourceTypeFilters',
        allProfessionalPracticeFilters: 'getAllProfessionalPracticeFilters',
        allFormatFilters: 'getAllFormatFilters',
        allAcademicSubjectFilters: 'getAllAcademicSubjectFilters',
        allGradeLevelFilters: 'getAllGradeLevelFilters',
        allNEATodayFilters: 'getAllNEATodayFilters',

        allThemeFilters: 'getAllThemeFilters',
        allReadingLevelFilters: 'getAllReadingLevelFilters',
        allGenreFilters: 'getAllGenreFilters',

        allActionTypeFilters: 'getAllActionTypeFilters',
        allCongressFilters: 'getAllCongressFilters',
        allPositionFilters: 'getAllPositionFilters',
        allChamberFilters: 'getAllChamberFilters',
        allFederalDepartmentFilters: 'getAllFederalDepartmentFilters',
        allFederalCommentsYearFilters: 'getAllFederalCommentsYearFilters',
        allQuickActionFilters: 'getAllQuickActionFilters',
        allFederalLegislationIssueFilters: 'getAllFederalLegislationIssueFilters',

        allNeaTodaySectionFilters: 'getAllNeaTodaySectionFilters',

        additionalParameters: 'getAdditionalParameters',

        initial: 'getInitial',
        pageIntro: 'getPageIntro'
      }),
      featuredNodesClass() {
        if (this.isBills) {
          return 'featured-bills'
        }

        if (this.isLettersAndTestimony) {
          return 'featured-letters'
        }

        return 'featured-resources'
      },
      featuredNodesTitle() {
        if (this.isBills) {
          return 'Featured Bills'
        }

        if (this.isLettersAndTestimony) {
          return 'Featured Letters & Testimony'
        }

        if (this.isTakeAction || this.isEdJusticeTakeAction) {
          // No title for this element.
          return null
        }

        if (this.isResourceLibrary || this.isEdJusticeResourceLibrary) {
          return 'Featured Resources'
        }

        if (this.isProfessionalDevelopmentResources) {
          return 'Featured Workshops'
        }

        if (this.isNewFromNEA || this.isEdJusticeSeeTheLatest || this.isNEATodayNewsAndArticles) {
          return 'Featured Stories'
        }

        if (this.isResearchAndReports) {
          return 'Featured Reports'
        }

        if (this.isSchoolMe) {
          return 'Featured Podcasts'
        }
      },
      isSearch() {
        return this.route === 'search'
      },
      isFederalEducationFunding() {
        return this.route === 'federal_education_funding'
      },
      isFindYourBook() {
        return this.route === 'find_your_book'
      },
      isNewFromNEA() {
        return this.route === 'new_from_nea'
      },
      isToolsAndTips() {
        return this.route === 'tools_and_tips'
      },
      isProfessionalDevelopmentResources() {
        return this.route === 'professional_learning_resources'
      },
      isResearchAndReports() {
        return this.route === 'research_and_reports'
      },
      isSchoolMe() {
        return this.route === 'school_me'
      },
      isResourceLibrary() {
        return this.route === 'resource_library'
      },
      isEdJusticeResourceLibrary() {
        return this.route === 'edjustice_resource_library'
      },
      isEdJusticeSeeTheLatest() {
        return this.route === 'edjustice_see_the_latest'
      },
      isTakeAction() {
        return this.route === 'take_action'
      },
      isEdJusticeTakeAction() {
        return this.route === 'edjustice_take_action'
      },
      isBills() {
        return this.route === 'bills'
      },
      isFederalComments() {
        return this.route === 'federal_comments'
      },
      isLettersAndTestimony() {
        return this.route === 'letters_and_testimony'
      },
      isNEATodayNewsAndArticles() {
        return this.route === 'nea_today_news_and_articles'
      },
      route () {
        return this.$route.name
      },
      title() {
        if(!this.search_settings[this.route].title) {
          return this.pageIntro[this.route] ? this.pageIntro[this.route].title : ''
        }
        return this.search_settings[this.route] && this.search_settings[this.route].title ? this.search_settings[this.route].title : ''
      },
      summary() {
        if(!this.search_settings[this.route].summary) {
          return this.pageIntro[this.route] ? this.pageIntro[this.route].summary : ''
        }
        return this.search_settings[this.route] && this.search_settings[this.route].summary ? this.search_settings[this.route].summary : ''
      },
      sortByDate() {
        return this.searchTerm === ''
      },
      hasKeyword() {
        return true;
      },
      hasTypeFilter() {
        return this.search_settings[this.route].type
      },
      hasIssueFilter() {
        return this.search_settings[this.route].issue
      },
      hasStateFilter() {
        return this.search_settings[this.route].state
      },
      hasCampaignFilter() {
        return this.search_settings[this.route].campaign
      },
      hasRoleFilter() {
        return this.search_settings[this.route].role
      },
      hasProfessionalPracticeFilter() {
        return this.search_settings[this.route].professional_practice
      },
      hasFromNeaTodayFilter() {
        return this.search_settings[this.route].from_nea_today
      },
      hasFormatFilter() {
        return this.search_settings[this.route].format
      },
      hasAcademicSubjectFilter() {
        return this.search_settings[this.route].academic_subject
      },
      hasGradeLevelFilter() {
        return this.search_settings[this.route].grade_level
      },
      hasActionTypeFilter() {
        return this.search_settings[this.route].action_type
      },
      hasQuickActionFilter() {
        return this.search_settings[this.route].i_am_in_a_hurry
      },
      hasCongressFilter() {
        return this.search_settings[this.route].congress
      },
      hasPositionFilter() {
        return this.search_settings[this.route].position
      },
      hasChamberFilter() {
        return this.search_settings[this.route].chamber
      },
      hasFederalDepartmentFilter() {
        return this.search_settings[this.route].federal_department
      },
      hasFederalLegislationIssueFilter() {
        return this.search_settings[this.route].federal_legislation_issue
      },
      hasYearFilter() {
        return this.search_settings[this.route].year
      },
      hasSectionFilter() {
        return this.search_settings[this.route].nea_today_section
      }
    },
    methods: {
      query() {

        let $this = this

        let data

        if (this.isProfessionalDevelopmentResources || this.isFederalEducationFunding) {
          data = this.packageProfessionalResourceDevelopmentData()
        } else if (this.isFindYourBook) {
          data = this.packageFindYourBookData()
        } else if (this.isTakeAction || this.isEdJusticeTakeAction) {
          data = this.packageTakeActionData()
        } else if (this.isBills || this.isLettersAndTestimony) {
          data = this.packageBillsLettersAndTestimonyData()
        } else if (this.isFederalComments) {
          data = this.packageFederalCommentsData()
        } else {
          data = this.packageData()
        }

        // if there's no keyword sorts by date
        // otherwise sorts by relevance by default
        if (this.sortByDate) {
          data.sort_field = {"page": "publish_date"}
          data.sort_direction = {"page": "desc"}
        }

        // remove parent issue filter if children are selected
        if (data.filters.page.issue) {
          // search issue filters
          data.filters.page.issue = this.removeParentIssue(data.filters.page.issue)
        }

        data = this.removeUnusedFilters(data)

        this.packageUrl(data)

        data = this.setDefaultFilterValues(data)

        this.$store.commit('updateLocked', true)

        this.axios.post(this.api, data, this.headers)
          .then((response) => {

            $this.$store.commit('updateLocked', false)

            let dataPackage = {}
            dataPackage.currentCount = response.data.record_count
            dataPackage.totalCount = response.data.info.page.total_result_count
            dataPackage.totalPages = response.data.info.page.num_pages
            dataPackage.currentPage = response.data.info.page.current_page

            $this.$store.commit('updateResultsData', dataPackage)
            $this.$store.commit('updateResultsItems', response.data.records.page)
            $this.$store.commit('updateFullResponse', response)
            $this.$store.commit('updateFacets', response.data.info.page.facets)

            if ($this.initial) {
              if (data.filters && data.filters.page) {
                if (this.isProfessionalDevelopmentResources || this.isFederalEducationFunding) {
                  data.filters.page.issue ? $this.updateInitialFilters($this.allIssueFilters, data.filters.page.issue) : ''
                  data.filters.page.professional_practice ? $this.updateInitialFilters($this.allProfessionalPracticeFilters, data.filters.page.professional_practice) : ''
                  if (this.isProfessionalDevelopmentResources) {
                    data.filters.page.session_format ? $this.updateInitialFilters($this.allFormatFilters, data.filters.page.session_format) : ''
                  }
                } else if (this.isFindYourBook) {
                  data.filters.page.theme ? $this.updateInitialFilters($this.allThemeFilters, data.filters.page.theme) : ''
                  data.filters.page.reading_level ? $this.updateInitialFilters($this.allReadingLevelFilters, data.filters.page.reading_level) : ''
                  data.filters.page.genre ? $this.updateInitialFilters($this.allGenreFilters, data.filters.page.genre) : ''
                } else if (this.isTakeAction || this.isEdJusticeTakeAction) {
                  data.filters.page.issue ? $this.updateInitialFilters($this.allIssueFilters, data.filters.page.issue) : ''
                  data.filters.page.action_type ? $this.updateInitialFilters($this.allActionTypeFilters, data.filters.page.action_type) : ''
                  data.filters.page.quick_action ? $this.updateInitialFilters($this.allQuickActionFilters, data.filters.page.quick_action) : ''
                } else if (this.isBills || this.isLettersAndTestimony) {
                  data.filters.page.federal_legislation_issue ? $this.updateInitialFilters($this.allFederalLegislationIssueFilters, data.filters.page.federal_legislation_issue) : ''
                  data.filters.page.congress ? $this.updateInitialFilters($this.allCongressFilters, data.filters.page.congress) : ''
                  data.filters.page.position ? $this.updateInitialFilters($this.allPositionFilters, data.filters.page.position) : ''
                  data.filters.page.chamber ? $this.updateInitialFilters($this.allChamberFilters, data.filters.page.chamber) : ''
                } else if (this.isFederalComments) {
                  data.filters.page.federal_legislation_issue ? $this.updateInitialFilters($this.allFederalLegislationIssueFilters, data.filters.page.federal_legislation_issue) : ''
                  data.filters.page.federal_department ? $this.updateInitialFilters($this.allFederalDepartmentFilters, data.filters.page.federal_department) : ''
                  data.filters.page.federal_comments_year ? $this.updateInitialFilters($this.allFederalCommentsYearFilters, data.filters.page.federal_comments_year) : ''
                } else if (this.isEdJusticeResourceLibrary) {
                  data.filters.page.group_one ? $this.updateInitialFilters($this.allGroupOneFilters, data.filters.page.group_one) : ''
                  data.filters.page.issue ? $this.updateInitialFilters($this.allIssueFilters, data.filters.page.issue) : ''
                } else if (this.isEdJusticeSeeTheLatest) {
                  data.filters.page.group_one ? $this.updateInitialFilters($this.allGroupOneFilters, data.filters.page.group_one) : ''
                  data.filters.page.issue ? $this.updateInitialFilters($this.allIssueFilters, data.filters.page.issue) : ''
                  data.filters.page.state ? $this.updateInitialFilters($this.allStateFilters, data.filters.page.state) : ''
                  data.filters.page.role ? $this.updateInitialFilters($this.allRoleFilters, data.filters.page.role) : ''
                } else {
                  data.filters.page.issue ? $this.updateInitialFilters($this.allIssueFilters, data.filters.page.issue) : ''
                  data.filters.page.nea_today_section ? $this.updateInitialFilters($this.allNeaTodaySectionFilters, data.filters.page.nea_today_section) : ''
                  data.filters.page.state ? $this.updateInitialFilters($this.allStateFilters, data.filters.page.state) : ''
                  data.filters.page.campaign ? $this.updateInitialFilters($this.allCampaignFilters, data.filters.page.campaign) : ''
                  data.filters.page.academic_subject ? $this.updateInitialFilters($this.allAcademicSubjectFilters, data.filters.page.academic_subject) : ''
                  data.filters.page.grade_level ? $this.updateInitialFilters($this.allGradeLevelFilters, data.filters.page.grade_level) : ''
                  data.filters.page.group_one ? $this.updateInitialFilters($this.allGroupOneFilters, data.filters.page.group_one) : ''
                  data.filters.page.role ? $this.updateInitialFilters($this.allRoleFilters, data.filters.page.role) : ''
                  data.filters.page.year ? $this.updateInitialFilters($this.allYearFilters, data.filters.page.year) : ''
                  data.filters.page.professional_practice ? $this.updateInitialFilters($this.allProfessionalPracticeFilters, data.filters.page.professional_practice) : ''
                  data.filters.page.nea_today ? $this.updateInitialFilters($this.allNEATodayFilters, data.filters.page.nea_today) : ''
                }
              }
              $this.$store.commit('updateInitial', false)
            }
            $this.newFacetCounts(data, response)

          }).catch(function (error) {
        })
      },
      autocompleteQuery() {

        let $this = this

        let data

        if (this.isProfessionalDevelopmentResources || this.isFederalEducationFunding) {
          data = this.packageProfessionalResourceDevelopmentData()
        } else if (this.isFindYourBook) {
          data = this.packageFindYourBookData()
        } else if (this.isTakeAction) {
          data = this.packageTakeActionData()
        } else if (this.isBills || this.isLettersAndTestimony) {
          data = this.packageBillsLettersAndTestimonyData()
        } else {
          data = this.packageData()
        }

        // remove parent issue filter if children are selected
        if (data.filters.page.issue) {
          // search issue filters
          data.filters.page.issue = this.removeParentIssue(data.filters.page.issue)
        }

        data = this.removeUnusedFilters(data)

        data = this.setDefaultFilterValues(data)

        data.q = this.autocompleteTerm;
        data.per_page = "5";
        data.page = "1";

        this.axios.post(this.api, data, this.headers)
          .then(function (response) {

            let dataPackage = {}
            dataPackage.currentCount = response.data.record_count
            dataPackage.totalCount = response.data.info.page.total_result_count
            dataPackage.totalPages = response.data.info.page.num_pages
            dataPackage.currentPage = response.data.info.page.current_page

            $this.$store.commit('updateAutocompleteResultsData', dataPackage)
            $this.$store.commit('updateAutocompleteResultsItems', response.data.records.page)

          }).catch(function (error) {
        })
      },
      newFacetCounts: function (queryData, responseData) {

        // @TODO refactor
        // @TODO simply do not update the facets for the taxonomy whose item you just clicked (for OR taxonomies)
        // @TODO only update it when another taxonomy is clicked

        // NOTE: Swiftype does not return counts for non-selected facet values once one of them is applied as a filter.
        // We need a separate query for each filter, removing the selected filter from query, to get the
        // counts for the non-selected facet values

        let $this = this

        if (queryData && queryData.filters && queryData.filters.page) {

          if (this.isProfessionalDevelopmentResources || this.isFederalEducationFunding) {
            $this.$store.commit('updateNewIssueCount', responseData.data.info.page.facets.issue)
            $this.$store.commit('updateNewProfessionalPracticeCount', responseData.data.info.page.facets.professional_practice)
            $this.$store.commit('updateNewFormatCount', responseData.data.info.page.facets.session_format)


            if (queryData.filters.page.issue) {
              if (queryData.filters.page.issue.length > 0) {
                let issueData = JSON.parse(JSON.stringify(queryData))
                delete issueData.filters.page.issue
                this.axios.post(this.api, issueData, this.headers)
                  .then(function (response) {
                    if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                      $this.$store.commit('updateNewIssueCount', response.data.info.page.facets.issue)
                    }
                  })
              }
            }

            if (queryData.filters.page.professional_practice) {
              if (queryData.filters.page.professional_practice.length > 0) {
                let professionalPracticeData = JSON.parse(JSON.stringify(queryData))
                delete professionalPracticeData.filters.page.professional_practice
                this.axios.post(this.api, professionalPracticeData, this.headers)
                    .then(function (response) {
                      if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                        $this.$store.commit('updateNewProfessionalPracticeCount', response.data.info.page.facets.professional_practice)
                      }
                    })
              }
            }

            if (queryData.filters.page.session_format) {
              if (queryData.filters.page.session_format.length > 0) {
                let sessionFormatData = JSON.parse(JSON.stringify(queryData))
                delete sessionFormatData.filters.page.session_format
                this.axios.post(this.api, sessionFormatData, this.headers)
                  .then(function (response) {
                    if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                      $this.$store.commit('updateNewFormatCount', response.data.info.page.facets.session_format)
                    }
                  })
              }
            }

          } else if (this.isFindYourBook) {
            $this.$store.commit('updateNewThemeCount', responseData.data.info.page.facets.theme)
            $this.$store.commit('updateNewReadingLevelCount', responseData.data.info.page.facets.reading_level)
            $this.$store.commit('updateNewGenreCount', responseData.data.info.page.facets.genre)

            if (queryData.filters.page.theme) {
              if (queryData.filters.page.theme.length > 0) {
                let themeData = JSON.parse(JSON.stringify(queryData))
                delete themeData.filters.page.theme
                this.axios.post(this.api, themeData, this.headers)
                  .then(function (response) {
                    if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                      $this.$store.commit('updateNewThemeCount', response.data.info.page.facets.theme)
                    }
                  })
              }
            }

            if (queryData.filters.page.reading_level) {
              if (queryData.filters.page.reading_level.length > 0) {
                let readingLevelData = JSON.parse(JSON.stringify(queryData))
                delete readingLevelData.filters.page.reading_level
                this.axios.post(this.api, readingLevelData, this.headers)
                  .then(function (response) {
                    if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                      $this.$store.commit('updateNewReadingLevelCount', response.data.info.page.facets.reading_level)
                    }
                  })
              }
            }

            if (queryData.filters.page.genre) {
              if (queryData.filters.page.genre.length > 0) {
                let genreData = JSON.parse(JSON.stringify(queryData))
                delete genreData.filters.page.genre
                this.axios.post(this.api, genreData, this.headers)
                  .then(function (response) {
                    if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                      $this.$store.commit('updateNewGenreCount', response.data.info.page.facets.genre)
                    }
                  })
              }
            }
          } else if (this.isTakeAction || this.isEdJusticeTakeAction) {
            $this.$store.commit('updateNewIssueCount', responseData.data.info.page.facets.issue)
            $this.$store.commit('updateNewActionTypeCount', responseData.data.info.page.facets.action_type)
            $this.$store.commit('updateNewQuickActionCount', responseData.data.info.page.facets.quick_action)

            if (queryData.filters.page.issue) {
              if (queryData.filters.page.issue.length > 0) {
                let issueData = JSON.parse(JSON.stringify(queryData))
                delete issueData.filters.page.issue
                this.axios.post(this.api, issueData, this.headers)
                    .then(function (response) {
                      if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                        $this.$store.commit('updateNewIssueCount', response.data.info.page.facets.issue)
                      }
                    })
              }
            }

            if (queryData.filters.page.action_type) {
              if (queryData.filters.page.action_type.length > 0) {
                let actionTypeData = JSON.parse(JSON.stringify(queryData))
                delete actionTypeData.filters.page.action_type
                this.axios.post(this.api, actionTypeData, this.headers)
                    .then(function (response) {
                      if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                        $this.$store.commit('updateNewActionTypeCount', response.data.info.page.facets.action_type)
                      }
                    })
              }
            }

            if (queryData.filters.page.quick_action) {
              if (queryData.filters.page.quick_action.length > 0) {
                let quickActionData = JSON.parse(JSON.stringify(queryData))
                delete quickActionData.filters.page.quick_action
                this.axios.post(this.api, quickActionData, this.headers)
                    .then(function (response) {
                      if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                        $this.$store.commit('updateNewQuickActionCount', response.data.info.page.facets.quick_action)
                      }
                    })
              }
            }
          } else if (this.isBills || this.isLettersAndTestimony) {
            $this.$store.commit('updateNewFederalLegislationIssueCount', responseData.data.info.page.facets.federal_legislation_issue)
            $this.$store.commit('updateNewCongressCount', responseData.data.info.page.facets.congress)
            $this.$store.commit('updateNewPositionCount', responseData.data.info.page.facets.position)
            $this.$store.commit('updateNewChamberCount', responseData.data.info.page.facets.chamber)

            if (queryData.filters.page.federal_legislation_issue) {
              if (queryData.filters.page.federal_legislation_issue.length > 0) {
                let issueData = JSON.parse(JSON.stringify(queryData))
                delete issueData.filters.page.federal_legislation_issue
                this.axios.post(this.api, issueData, this.headers)
                    .then(function (response) {
                      if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                        $this.$store.commit('updateNewFederalLegislationIssueCount', response.data.info.page.facets.federal_legislation_issue)
                      }
                    })
              }
            }

            if (queryData.filters.page.congress) {
              if (queryData.filters.page.congress.length > 0) {
                let congressData = JSON.parse(JSON.stringify(queryData))
                delete congressData.filters.page.congress
                this.axios.post(this.api, congressData, this.headers)
                    .then(function (response) {
                      if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                        $this.$store.commit('updateNewCongressCount', response.data.info.page.facets.congress)
                      }
                    })
              }
            }

            if (queryData.filters.page.position) {
              if (queryData.filters.page.position.length > 0) {
                let positionData = JSON.parse(JSON.stringify(queryData))
                delete positionData.filters.page.position
                this.axios.post(this.api, positionData, this.headers)
                    .then(function (response) {
                      if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                        $this.$store.commit('updateNewPositionCount', response.data.info.page.facets.position)
                      }
                    })
              }
            }

            if (queryData.filters.page.chamber) {
              if (queryData.filters.page.chamber.length > 0) {
                let chamberData = JSON.parse(JSON.stringify(queryData))
                delete chamberData.filters.page.chamber
                this.axios.post(this.api, chamberData, this.headers)
                    .then(function (response) {
                      if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                        $this.$store.commit('updateNewChamberCount', response.data.info.page.facets.chamber)
                      }
                    })
              }
            }
          } else if (this.isFederalComments) {
            const federalCommentsFilters = [
              {
                filterName: 'federal_legislation_issue',
                updateMethod: 'updateNewFederalLegislationIssueCount'
              },
              {
                filterName: 'federal_department',
                updateMethod: 'updateNewFederalDepartmentCount'
              },
              {
                filterName: 'federal_comments_year',
                updateMethod: 'updateNewFederalCommentsYearCount'
              }
            ]

            federalCommentsFilters.forEach(filterData => {
              $this.$store.commit(filterData.updateMethod, responseData.data.info.page.facets[filterData.filterName])

              if (queryData?.filters?.page[filterData.filterName]?.length > 0) {
                let issueData = JSON.parse(JSON.stringify(queryData))
                delete issueData.filters.page[filterData.filterName]
                this.axios.post(this.api, issueData, this.headers)
                  .then((response) => {
                    if (response?.data?.info?.page?.facets) {
                      $this.$store.commit(filterData.updateMethod, response.data.info.page.facets[filterData.filterName])
                    }
                  })
                  .catch((error) => {
                    console.log(error)
                  })
              }
            })
          } else {

            $this.$store.commit('updateNewGroupOneCount', responseData.data.info.page.facets.group_one)
            $this.$store.commit('updateNewProfessionalPracticeCount', responseData.data.info.page.facets.professional_practice)
            $this.$store.commit('updateNewRoleCount', responseData.data.info.page.facets.role)
            $this.$store.commit('updateNewYearCount', responseData.data.info.page.facets.year)
            $this.$store.commit('updateNewNEATodayCount', responseData.data.info.page.facets.nea_today)
            $this.$store.commit('updateNewNEATodaySectionCount', responseData.data.info.page.facets.nea_today_section)
            $this.$store.commit('updateNewIssueCount', responseData.data.info.page.facets.issue)
            $this.$store.commit('updateNewStateCount', responseData.data.info.page.facets.state)
            $this.$store.commit('updateNewCampaignCount', responseData.data.info.page.facets.campaign)
            $this.$store.commit('updateNewAcademicSubjectCount', responseData.data.info.page.facets.academic_subject)
            $this.$store.commit('updateNewGradeLevelCount', responseData.data.info.page.facets.grade_level)

            // OR across article_type and resource_type
            if (queryData.filters.page.group_one) {
              if (queryData.filters.page.group_one.length > 0) {
                let groupOneData = JSON.parse(JSON.stringify(queryData))
                delete groupOneData.filters.page.group_one
                this.axios.post(this.api, groupOneData, this.headers)
                  .then(function (response) {
                    if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                      $this.$store.commit('updateNewGroupOneCount', response.data.info.page.facets.group_one)
                    }
                  })
              }
            }

            // @TODO facet on parent goes away once children are selected
            if (queryData.filters.page.issue) {
              if (queryData.filters.page.issue.length > 0) {
                let issueData = JSON.parse(JSON.stringify(queryData))
                delete issueData.filters.page.issue
                this.axios.post(this.api, issueData, this.headers)
                  .then(function (response) {
                    if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                      $this.$store.commit('updateNewIssueCount', response.data.info.page.facets.issue)
                    }
                  })
              }
            }

            if (queryData.filters.page.state) {
              if (queryData.filters.page.state.length > 0) {
                let stateData = JSON.parse(JSON.stringify(queryData))
                delete stateData.filters.page.state
                this.axios.post(this.api, stateData, this.headers)
                  .then(function (response) {
                    if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                      $this.$store.commit('updateNewStateCount', response.data.info.page.facets.state)
                    }
                  })
              }
            }

            if (queryData.filters.page.nea_today_section) {
              if (queryData.filters.page.nea_today_section.length > 0) {
                let neaTodaySectionData = JSON.parse(JSON.stringify(queryData))
                delete neaTodaySectionData.filters.page.nea_today_section
                this.axios.post(this.api, neaTodaySectionData, this.headers)
                  .then(function (response) {
                    if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                      $this.$store.commit('updateNewNeaTodaySectionCount', response.data.info.page.facets.nea_today_section)
                    }
                  })
              }
            }

            if (queryData.filters.page.campaign) {
              if (queryData.filters.page.campaign.length > 0) {
                let campaignData = JSON.parse(JSON.stringify(queryData))
                delete campaignData.filters.page.campaign
                this.axios.post(this.api, campaignData, this.headers)
                  .then(function (response) {
                    if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                      $this.$store.commit('updateNewCampaignCount', response.data.info.page.facets.campaign)
                    }
                  })
              }
            }

            if (queryData.filters.page.academic_subject) {
              if (queryData.filters.page.academic_subject.length > 0) {
                let academicSubjectData = JSON.parse(JSON.stringify(queryData))
                delete academicSubjectData.filters.page.academic_subject
                this.axios.post(this.api, academicSubjectData, this.headers)
                  .then(function (response) {
                    if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                      $this.$store.commit('updateNewAcademicSubjectCount', response.data.info.page.facets.academic_subject)
                    }
                  })
              }
            }

            if (queryData.filters.page.grade_level) {
              if (queryData.filters.page.grade_level.length > 0) {
                let gradeLevelData = JSON.parse(JSON.stringify(queryData))
                delete gradeLevelData.filters.page.grade_level
                this.axios.post(this.api, gradeLevelData, this.headers)
                  .then(function (response) {
                    if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                      $this.$store.commit('updateNewGradeLevelCount', response.data.info.page.facets.grade_level)
                    }
                  })
              }
            }

            if (queryData.filters.page.professional_practice) {
              if (queryData.filters.page.professional_practice.length > 0) {
                let professionalPracticeData = JSON.parse(JSON.stringify(queryData))
                delete professionalPracticeData.filters.page.professional_practice
                this.axios.post(this.api, professionalPracticeData, this.headers)
                    .then(function (response) {
                      if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                        $this.$store.commit('updateNewProfessionalPracticeCount', response.data.info.page.facets.professional_practice)
                      }
                    })
              }
            }

            if (queryData.filters.page.role) {
              if (queryData.filters.page.role.length > 0) {
                let roleData = JSON.parse(JSON.stringify(queryData))
                delete roleData.filters.page.role
                this.axios.post(this.api, roleData, this.headers)
                    .then(function (response) {
                      if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                        $this.$store.commit('updateNewRoleCount', response.data.info.page.facets.role)
                      }
                    })
              }
            }

            if (queryData.filters.page.year) {
              if (queryData.filters.page.year.length > 0) {
                let yearData = JSON.parse(JSON.stringify(queryData))
                delete yearData.filters.page.year
                this.axios.post(this.api, yearData, this.headers)
                    .then(function (response) {
                      if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                        $this.$store.commit('updateNewYearCount', response.data.info.page.facets.year)
                      }
                    })
              }
            }

            if (queryData.filters.page.nea_today) {
              if (queryData.filters.page.nea_today.length > 0) {
                let neaTodayData = JSON.parse(JSON.stringify(queryData))
                delete neaTodayData.filters.page.nea_today
                this.axios.post(this.api, neaTodayData, this.headers)
                    .then(function (response) {
                      if (response && response.data && response.data.info && response.data.info.page && response.data.info.page.facets) {
                        $this.$store.commit('updateNewNEATodayCount', response.data.info.page.facets.nea_today)
                      }
                    })
              }
            }

          }

        }
      },
      getActiveFiltersByKind(kind) {
        let set = this.activeFilters.filter(el => {
          return el.kind === kind
        })

        let values = set.map(el => {
          return el.value
        })

        return values.length > 0 ? values : []
      },
      packageUrl(data) {
        let fullUrlString = this.$route.path + '?'

        if (this.initial) {
          const searchString = String(window.location.search)
          const args = new URLSearchParams(searchString)
          this.additionalParameters.forEach((parameter) => {
            if (args.has(parameter)) {
              this.additional_parameters_string += args.get(parameter) ? (parameter + '=' + args.get(parameter) + '&') : '';
            }
          });
        }

        if (data.q && data.q !== '') {
          fullUrlString += "q="
          fullUrlString += data.q
          fullUrlString += "&"
        }

        // @TODO refactor
        if (data.filters && data.filters.page && data.filters.page && Object.keys(data.filters.page).length > 0) {
          Object.keys(data.filters.page).forEach(key => {
            // AND within filters
            if (data.filters.page[key] && data.filters.page[key].values && data.filters.page[key].values.length > 0) {
              // fullUrlString += key
              // fullUrlString += "="
              // fullUrlString += data.filters.page[key].values.toString()
              // fullUrlString += "&"
              let parameters = {}
              Object.keys(data.filters.page[key]).forEach(index => {
                let parameter = this.getParameter(key, data.filters.page[key][index])
                let value = data.filters.page[key][index] === 'nea_today' || data.filters.page[key][index] === 'quick_action' ? '1' : data.filters.page[key][index]

                if (parameters[parameter] === undefined) {
                  parameters[parameter] = []
                }
                parameters[parameter].push(value)
              })
              Object.keys(parameters).forEach(parameter => {
                fullUrlString += parameter
                fullUrlString += "="
                fullUrlString += parameters[parameter].toString()
                fullUrlString += "&"
              })
            }
            // OR within filters
            else if (data.filters.page[key] && data.filters.page[key].length > 0) {
              // fullUrlString += key
              // fullUrlString += "="
              // fullUrlString += data.filters.page[key].toString()
              // fullUrlString += "&"
              let parameters = {}
              Object.keys(data.filters.page[key]).forEach(index => {
                let parameter = this.getParameter(key, data.filters.page[key][index])
                let value = data.filters.page[key][index] === 'nea_today' || data.filters.page[key][index] === 'quick_action' ? '1' : data.filters.page[key][index]
                if (parameters[parameter] === undefined) {
                  parameters[parameter] = []
                }
                parameters[parameter].push(value)
              })
              Object.keys(parameters).forEach(parameter => {
                fullUrlString += parameter
                fullUrlString += "="
                fullUrlString += parameters[parameter].toString()
                fullUrlString += "&"
              })
            }
          })
        }

        fullUrlString += this.additional_parameters_string
        history.replaceState({}, this.$route.path, fullUrlString)
      },
      removeUnusedFilters(data) {

        if (this.isProfessionalDevelopmentResources || this.isFederalEducationFunding) {
          if (data.filters && data.filters.page && data.filters.page.group_one.length === 0) {
            delete data.filters.page.group_one
          }

          if (data.filters && data.filters.page && data.filters.page.professional_practice && data.filters.page.professional_practice.length === 0) {
            delete data.filters.page.professional_practice
          }

          if (data.filters && data.filters.page && data.filters.page.academic_subject && data.filters.page.academic_subject.length === 0) {
            delete data.filters.page.academic_subject
          }

          if (data.filters && data.filters.page && data.filters.page.session_format && data.filters.page.session_format.length === 0) {
            delete data.filters.page.session_format
          }

          if (data.filters && data.filters.page && data.filters.page.issue && data.filters.page.issue.length === 0) {
            delete data.filters.page.issue
          }

          if (data.filters && data.filters.page && data.filters.page.type && data.filters.page.type.length === 0) {
            delete data.filters.page.type
          }
        } else if (this.isFindYourBook) {
          if (data.filters && data.filters.page && data.filters.page.genre && data.filters.page.genre.length === 0) {
            delete data.filters.page.genre
          }

          if (data.filters && data.filters.page && data.filters.page.group_one && data.filters.page.group_one.length === 0) {
            delete data.filters.page.group_one
          }

          if (data.filters && data.filters.page && data.filters.page.reading_leve && data.filters.page.reading_level.length === 0) {
            delete data.filters.page.reading_level
          }

          if (data.filters && data.filters.page && data.filters.page.theme && data.filters.page.theme.length === 0) {
            delete data.filters.page.theme
          }

          if (data.filters && data.filters.page && data.filters.page.type && data.filters.page.type.length === 0) {
            delete data.filters.page.type
          }

          if (data.filters && data.filters.page && Object.keys(data.filters.page).length === 0) {
            delete data.filters.page
          }

          if (data.filters && Object.keys(data.filters).length === 0) {
            delete data.filters
          }
        } else if (this.isTakeAction || this.isEdJusticeTakeAction) {
          if (data.filters && data.filters.page && data.filters.page.issue && data.filters.page.issue.length === 0) {
            delete data.filters.page.issue
          }

          if (data.filters && data.filters.page && data.filters.page.action_type && data.filters.page.action_type.length === 0) {
            delete data.filters.page.action_type
          }

          if (data.filters && data.filters.page && data.filters.page.quick_action && data.filters.page.quick_action.length === 0) {
            delete data.filters.page.quick_action
          }

          // if (data.filters && data.filters.page && data.filters.page.campaign.length === 0) {
          //   delete data.filters.page.campaign
          // }

          if (data.filters && data.filters.page && data.filters.page.type && data.filters.page.type.length === 0) {
            delete data.filters.page.type
          }
        } else if (this.isBills || this.isLettersAndTestimony) {
          if (data.filters && data.filters.page && data.filters.page.federal_legislation_issue && data.filters.page.federal_legislation_issue.length === 0) {
            delete data.filters.page.federal_legislation_issue
          }

          if (data.filters && data.filters.page && data.filters.page.congress && data.filters.page.congress.length === 0) {
            delete data.filters.page.congress
          }

          if (data.filters && data.filters.page && data.filters.page.position && data.filters.page.position.length === 0) {
            delete data.filters.page.position
          }

          if (data.filters && data.filters.page && data.filters.page.chamber && data.filters.page.chamber.length === 0) {
            delete data.filters.page.chamber
          }

          if (data.filters && data.filters.page && data.filters.page.type && data.filters.page.type.length === 0) {
            delete data.filters.page.type
          }
        } else if (this.isFederalComments) {
          if (data?.filters?.page?.federal_legislation_issue?.length === 0) {
            delete data.filters.page.federal_legislation_issue
          }
          if (data?.filters?.page?.federal_department?.length === 0) {
            delete data.filters.page.federal_department
          }
          if (data?.filters?.page?.federal_comments_year?.length === 0) {
            delete data.filters.page.federal_comments_year
          }
          if (data?.filters?.page?.type?.length === 0) {
            delete data.filters.page.type
          }
        } else {
          // OR across filters
          if (data.filters && data.filters.page && data.filters.page.group_one.length === 0) {
            delete data.filters.page.group_one
          }

          if (data.filters && data.filters.page && data.filters.page.professional_practice && data.filters.page.professional_practice.length === 0) {
            delete data.filters.page.professional_practice
          }

          if (data.filters && data.filters.page && data.filters.page.role && data.filters.page.role.length === 0) {
            delete data.filters.page.role
          }

          if (data.filters && data.filters.page && data.filters.page.year && data.filters.page.year.length === 0) {
            delete data.filters.page.year
          }

          if (data.filters && data.filters.page && data.filters.page.nea_today && data.filters.page.nea_today.length === 0) {
            delete data.filters.page.nea_today
          }

          if (data.filters && data.filters.page && data.filters.page.nea_today_section && data.filters.page.nea_today_section.length === 0) {
            delete data.filters.page.nea_today_section
          }

          // AND across filters
          if (data.filters && data.filters.page && data.filters.page.campaign.length === 0) {
            delete data.filters.page.campaign
          }

          if (data.filters && data.filters.page && data.filters.page.academic_subject.length === 0) {
            delete data.filters.page.academic_subject
          }

          if (data.filters && data.filters.page && data.filters.page.grade_level.length === 0) {
            delete data.filters.page.grade_level
          }

          //
          if (data.filters && data.filters.page && data.filters.page.state.length === 0) {
            delete data.filters.page.state
          }

          //
          if (data.filters && data.filters.page && data.filters.page.issue && data.filters.page.issue.length === 0) {
            delete data.filters.page.issue
          }

          if (data.filters && data.filters.page && data.filters.page.type && data.filters.page.type.length === 0) {
            delete data.filters.page.type
          }
        }

        return data
      },
      setDefaultFilterValues(data) {
        // if on /resource-library
        if (this.isResourceLibrary) {
          data.filters.page.type = ["report", "resource", "issue_explainer", "toolkit", "nea_today_issue"]

          if (this.isOEA) {
            // Exclude Eye on Equity events.
            data.filters.page.event_type = [`!${eyeOnEquityTid}`]
          }
        }

        if (this.isEdJusticeResourceLibrary) {
          data.filters.page.type = ["report", "resource", "issue_explainer", "toolkit"]
          data.filters.page.campaign = [`${edjusticeTid}`]
        }

        if (this.isEdJusticeSeeTheLatest) {
          data.filters.page.type = ["article", "longform"]
          data.filters.page.campaign = [`${edjusticeTid}`]
        }

        // if on /professional-excellence/professional-learning/resources
        if (this.isProfessionalDevelopmentResources) {
          data.filters.page.type = "resource"

          if (professionalDevelopmentTid) {
            data.filters.page.group_one = `${professionalDevelopmentTid}`
          }

        }

        // if on /filtered-list/resource-type/book-recommendation
        if (this.isFindYourBook) {
          data.filters.page.type = "resource"

          if (bookRecommendationTid) {
            data.filters.page.group_one = `${bookRecommendationTid}`
          }
        }

        // if on /advocating-for-change/new-from-nea
        if (this.isNewFromNEA) {
          data.filters.page.type = ["article", "longform"]
        }

        // if on /publications/all-news-articles
        if (this.isNEATodayNewsAndArticles) {
          // @TODO confirm types
          // data.filters.page.type = ["!bill","!letter", "!business_item"]
          data.filters.page.type = ["article", "longform"]
          data.filters.page.nea_today = ["1"]
        }

        if (this.isToolsAndTips) {
          // Set defaults.
          data.filters.page.type = "resource"

          data.filters.page.resource_type = [
            `${activityTid}`,
            `${adviceTid}`,
            `${podcastTid}`,
          ]

          if (bookRecommendationTid) {
            data.filters.page.resource_type.push(`${bookRecommendationTid}`)
          }
        }

        // if on /about-nea/grants-funding/federal-education-funding
        if (this.isFederalEducationFunding) {
          data.filters.page.type = "resource"

          if (federalFundingGuideTid) {
            data.filters.page.group_one = `${federalFundingGuideTid}`
          }

        }

        if (this.isSearch) {
          // Exclude bill and letter from sitewide search.
          data.filters.page.type = ["!bill","!letter", "!business_item"]
        }

        if (this.isTakeAction) {
          data.filters.page.type = "action"
        }

        if (this.isEdJusticeTakeAction) {
          data.filters.page.type = "action"
          data.filters.page.campaign = [`${edjusticeTid}`]
        }

        if (this.isBills) {
          data.filters.page.type = "bill"
        }

        if (this.isLettersAndTestimony) {
          data.filters.page.type = "letter"

          data.filters.page.letter_type = [
            `!${federalCommentTid}`,
          ]
        }

        if (this.isFederalComments) {
          data.filters.page.type = ["letter"]

          data.filters.page.letter_type = [
            `${federalCommentTid}`,
          ]
        }

        if (this.isResearchAndReports) {
          data.filters.page.type = ["report", "resource"]

          data.filters.page.resource_type = [
            `${reportTid}`,
          ]
        }

        if (this.isSchoolMe) {
          data.filters.page.type = ["resource"]

          data.filters.page.resource_type = [
            `${podcastTid}`,
          ]
        }

        // @TODO only resources? or both articles and resources?
        data.filters.page.is_ra_event_resource = ["!1"]

        return data
      },
      updateInitialFilters(filters, values) {
        // @TODO
        if (filters && values) {
          values.forEach(value => {
            for (const [i, filter] of Object.entries(filters)) {
              if (filter.value === value) {
                let activeFilters = this.activeFilters
                activeFilters.push(filter)
                this.$store.commit('updateActiveFilters', activeFilters)
              }
              if (filter.children) {
                for (const [i, child] of Object.entries(filter.children)) {
                  if (child.value === value) {
                    let activeFilters = this.activeFilters
                    activeFilters.push(child)
                    activeFilters.push(filter)
                    this.$store.commit('updateActiveFilters', activeFilters)
                  }
                }
              }
            }
          })
        }
      },
      removeParentIssue(data) {
        // look at each issue filter
        for (const [i, filter] of Object.entries(this.allIssueFilters)) {
          // if the filter is a parent and selected
          if (filter.children && data.includes(filter.value)) {
            // look at each filter child
            for (const [j, child] of Object.entries(filter.children)) {
              // if a child is also selected
              if (filter.children && data.includes(child.value)) {
                // then remove the parent from query
                let index = data.indexOf(filter.value)
                if (index !== -1) {
                  data.splice(index, 1);
                }
              }
            }
          }
        }
        return data
      },
      packageData() {
        const searchString = String(window.location.search)
        const args = new URLSearchParams(searchString)

        let data
        if (this.initial) {
          // this is the initial query, sent as the page loads.
          // Prepare the 'data' variable, which holds all the information we need for our Axios call to the Swiftype API.
          // This branch is for the 'initial' query, which happens only when the page loads. It gets paramters from the URL.

          let q = (args.has('q') ? args.get('q') : '')
          if (q !== this.searchTerm) {
            this.$store.commit('updateSearchTerm', q)
            this.$store.commit('updateAutocompleteTerm', q)
          }
          let article_type = args.has('article_type') ? args.get('article_type').split(',') : []
          let resource_type = args.has('resource_type') ? args.get('resource_type').split(',') : []
          let group_one = [...article_type, ...resource_type];

          data = {
            "q": ( this.hasKeyword && args.has('q') ? args.get('q') : ''),
            "per_page": this.perPage,
            "facets": {
              "page": ["type", "issue", "state", "campaign", "academic_subject", "grade_level", "group_one", "professional_practice", "role", "year", "nea_today", "nea_today_section"]
            },
            "page": this.currentPage,
            "filters": {
              "page": {
                "type": [],
                "issue": this.hasIssueFilter && args.has('issue') ? args.get('issue').split(',') : [],
                "state": this.hasStateFilter && args.has('state') ? args.get('state').split(',') : [],
                "campaign": this.hasCampaignFilter && args.has('campaign') ? args.get('campaign').split(',') : [],
                "academic_subject": this.hasAcademicSubjectFilter && args.has('academic_subject') ? args.get('academic_subject').split(',') : [],
                "grade_level": this.hasGradeLevelFilter && args.has('grade_level') ? args.get('grade_level').split(',') : [],

                // group one
                "group_one": this.hasTypeFilter ? group_one : [],
                "professional_practice": this.hasProfessionalPracticeFilter && args.has('professional_practice') ? args.get('professional_practice').split(',') : [],
                "role": this.hasRoleFilter && args.has('role') ? args.get('role').split(',') : [],
                "year": this.hasYearFilter && args.has('year') ? args.get('year').split(',') : [],
                "nea_today": this.hasFromNeaTodayFilter && args.has('nea_today') ? args.get('nea_today').split(',') : [],
                "nea_today_section": this.hasSectionFilter && args.has('nea_today_section') ? args.get('nea_today_section').split(',') : [],
              }
            },
          }

          // end intiial query
        } else {
          // This is for the standard query (used anytime we're not 'initial'). It uses the Vuex store to determine which options to send.
          // factor out into this.buildStandardQuery()
          data = {
            "q": this.hasKeyword ? this.searchTerm : '',
            "per_page": this.perPage,
            "facets": {
              "page": ["type", "issue", "state", "campaign", "academic_subject", "grade_level", "group_one", "professional_practice", "role", "year", "nea_today", "nea_today_section"]
            },
            "page": this.currentPage,
            "filters": {
              "page": {
                "type": [],
                "issue": this.hasIssueFilter ? this.getActiveFiltersByKind('issue') : [],
                "state": this.hasStateFilter ? this.getActiveFiltersByKind('state') : [],
                "campaign": this.hasCampaignFilter ? this.getActiveFiltersByKind('campaign') : [],
                "academic_subject": this.hasAcademicSubjectFilter ? this.getActiveFiltersByKind('academic_subject') : [],
                "grade_level": this.hasGradeLevelFilter ? this.getActiveFiltersByKind('grade_level') : [],

                // group one
                "group_one": this.hasTypeFilter ? this.getActiveFiltersByKind('group_one') : [],
                "professional_practice": this.hasProfessionalPracticeFilter ? this.getActiveFiltersByKind('professional_practice') : [],
                "role": this.hasRoleFilter ? this.getActiveFiltersByKind('role') : [],
                "year": this.hasYearFilter ? this.getActiveFiltersByKind('year') : [],
                "nea_today": this.hasFromNeaTodayFilter ? this.getActiveFiltersByKind('nea_today') : [],
                "nea_today_section": this.hasSectionFilter ? this.getActiveFiltersByKind('nea_today_section') : [],
              }
            },
          }
        }

        return data
      },
      packageProfessionalResourceDevelopmentData() {
        const searchString = String(window.location.search)
        const args = new URLSearchParams(searchString)

        let data
        if (this.initial) {
          // this is the initial query, sent as the page loads.
          // Prepare the 'data' variable, which holds all the information we need for our Axios call to the Swiftype API.
          // This branch is for the 'initial' query, which happens only when the page loads. It gets paramters from the URL.

          let q = (args.has('q') ? args.get('q') : '')
          if (q !== this.searchTerm) {
            this.$store.commit('updateSearchTerm', q)
            this.$store.commit('updateAutocompleteTerm', q)
          }

          data = {
            "q": (this.hasKeyword && args.has('q') ? args.get('q') : ''),
            "per_page": this.perPage,
            "facets": {
              "page": ["type", "issue", "academic_subject", "session_format", "group_one", "professional_practice"]
            },
            "page": this.currentPage,
            "filters": {
              "page": {
                "type": [],
                "issue": this.hasIssueFilter && args.has('issue') ? args.get('issue').split(',') : [],
                "group_one": [],
                "professional_practice": this.hasProfessionalPracticeFilter && args.has('professional_practice') ? args.get('professional_practice').split(',') : [],
                "academic_subject": this.hasAcademicSubjectFilter && args.has('academic_subject') ? args.get('academic_subject').split(',') : [],
                "session_format": this.hasFormatFilter && args.has('session_format') ? args.get('session_format').split(',') : [],
              }
            },
          }
          // end initial query
        } else {
          // This is for the standard query (used anytime we're not 'initial'). It uses the Vuex store to determine which options to send.
          // factor out into this.buildStandardQuery()
          data = {
            "q": this.hasKeyword ? this.searchTerm : '',
            "per_page": this.perPage,
            "facets": {
              "page": ["type", "issue", "academic_subject", "session_format", "group_one", "professional_practice"]
            },
            "page": this.currentPage,
            "filters": {
              "page": {
                "type": [],
                "issue": this.hasIssueFilter ? this.getActiveFiltersByKind('issue') : [],
                "group_one": [],
                "professional_practice": this.hasProfessionalPracticeFilter ? this.getActiveFiltersByKind('professional_practice') : [],
                "academic_subject": this.hasAcademicSubjectFilter ? this.getActiveFiltersByKind('academic_subject') : [],
                "session_format": this.hasFormatFilter ? this.getActiveFiltersByKind('session_format') : [],
              }
            },
          }
        }

        if (this.isProfessionalDevelopmentResources) {
          data.filters.page.issue = []
          data.filters.page.academic_subject = []
        }

        if (this.isFederalEducationFunding) {
          data.filters.page.session_format = []
        }

        return data
      },
      packageFindYourBookData() {
        const searchString = String(window.location.search)
        const args = new URLSearchParams(searchString)

        let data
        if (this.initial) {
          // this is the initial query, sent as the page loads.
          // Prepare the 'data' variable, which holds all the information we need for our Axios call to the Swiftype API.
          // This branch is for the 'initial' query, which happens only when the page loads. It gets paramters from the URL.

          let q = (args.has('q') ? args.get('q') : '')
          if (q !== this.searchTerm) {
            this.$store.commit('updateSearchTerm', q)
            this.$store.commit('updateAutocompleteTerm', q)
          }

          data = {
            "q": (args.has('q') ? args.get('q') : ''),
            "per_page": this.perPage,
            "facets": {
              "page": ["type", "group_one", "theme", "reading_level", "genre"]
            },
            "page": this.currentPage,
            "filters": {
              "page": {
                "type": [],
                "theme": args.has('theme') ? args.get('theme').split(',') : [],
                "reading_level": args.has('reading_level') ? args.get('reading_level').split(',') : [],
                "group_one": [],
                "genre": args.has('genre') ? args.get('genre').split(',') : [],
              }
            },
          }
          // end intiial query
        } else {
          // This is for the standard query (used anytime we're not 'initial'). It uses the Vuex store to determine which options to send.
          // factor out into this.buildStandardQuery()
          data = {
            "q": this.searchTerm,
            "per_page": this.perPage,
            "facets": {
              "page": ["type", "group_one", "theme", "reading_level", "genre"]
            },
            "page": this.currentPage,
            "filters": {
              "page": {
                "type": [],
                "theme": this.getActiveFiltersByKind('theme'),
                "reading_level": this.getActiveFiltersByKind('reading_level'),
                "group_one": [],
                "genre": this.getActiveFiltersByKind('genre'),
              }
            },
          }
        }
        return data
      },
      packageTakeActionData() {
        const searchString = String(window.location.search)
        const args = new URLSearchParams(searchString)

        let data
        if (this.initial) {
          // this is the initial query, sent as the page loads.
          // Prepare the 'data' variable, which holds all the information we need for our Axios call to the Swiftype API.
          // This branch is for the 'initial' query, which happens only when the page loads. It gets paramters from the URL.

          let q = (args.has('q') ? args.get('q') : '')
          if (q !== this.searchTerm) {
            this.$store.commit('updateSearchTerm', q)
            this.$store.commit('updateAutocompleteTerm', q)
          }

          data = {
            "q": (args.has('q') ? args.get('q') : ''),
            "per_page": this.perPage,
            "facets": {
              "page": ["type", "issue", "action_type", "quick_action"]
            },
            "page": this.currentPage,
            "filters": {
              "page": {
                "type": [],
                "issue": args.has('issue') ? args.get('issue').split(',') : [],
                "action_type": args.has('action_type') ? args.get('action_type').split(',') : [],
                "quick_action": args.has('quick_action') ? args.get('quick_action').split(',') : [],
              }
            },
          }
          // end intiial query
        } else {
          // This is for the standard query (used anytime we're not 'initial'). It uses the Vuex store to determine which options to send.
          // factor out into this.buildStandardQuery()
          data = {
            "q": this.searchTerm,
            "per_page": this.perPage,
            "facets": {
              "page": ["type", "issue", "action_type", "quick_action"]
            },
            "page": this.currentPage,
            "filters": {
              "page": {
                "type": [],
                "issue": this.getActiveFiltersByKind('issue'),
                "action_type": this.getActiveFiltersByKind('action_type'),
                "quick_action": this.getActiveFiltersByKind('quick_action'),
              }
            },
          }
        }
        return data
      },
      packageBillsLettersAndTestimonyData() {
        const searchString = String(window.location.search)
        const args = new URLSearchParams(searchString)

        let data
        if (this.initial) {
          // this is the initial query, sent as the page loads.
          // Prepare the 'data' variable, which holds all the information we need for our Axios call to the Swiftype API.
          // This branch is for the 'initial' query, which happens only when the page loads. It gets paramters from the URL.

          let q = (args.has('q') ? args.get('q') : '')
          if (q !== this.searchTerm) {
            this.$store.commit('updateSearchTerm', q)
            this.$store.commit('updateAutocompleteTerm', q)
          }

          data = {
            "q": (args.has('q') ? args.get('q') : ''),
            "per_page": this.perPage,
            "facets": {
              "page": ["type", "federal_legislation_issue", "congress", "position", "chamber"]
            },
            "page": this.currentPage,
            "filters": {
              "page": {
                "type": [],
                "federal_legislation_issue": args.has('federal_legislation_issue') ? args.get('federal_legislation_issue').split(',') : [],
                "congress": args.has('congress') ? args.get('congress').split(',') : [],
                "position": args.has('position') ? args.get('position').split(',') : [],
                "chamber": args.has('chamber') ? args.get('chamber').split(',') : [],
              }
            },
          }
          // end intiial query
        } else {
          // This is for the standard query (used anytime we're not 'initial'). It uses the Vuex store to determine which options to send.
          // factor out into this.buildStandardQuery()
          data = {
            "q": this.searchTerm,
            "per_page": this.perPage,
            "facets": {
              "page": ["type", "federal_legislation_issue", "congress", "position", "chamber"]
            },
            "page": this.currentPage,
            "filters": {
              "page": {
                "type": [],
                "federal_legislation_issue": this.getActiveFiltersByKind('federal_legislation_issue'),
                "congress": this.getActiveFiltersByKind('congress'),
                "position": this.getActiveFiltersByKind('position'),
                "chamber": this.getActiveFiltersByKind('chamber'),
              }
            },
          }
        }
        return data
      },
      packageFederalCommentsData() {
        const searchString = String(window.location.search)
        const args = new URLSearchParams(searchString)

        let data
        if (this.initial) {
          let q = (args.has('q') ? args.get('q') : '')
          if (q !== this.searchTerm) {
            this.$store.commit('updateSearchTerm', q)
            this.$store.commit('updateAutocompleteTerm', q)
          }

          data = {
            "q": (args.has('q') ? args.get('q') : ''),
            "per_page": this.perPage,
            "facets": {
              "page": ["type", "federal_legislation_issue", "federal_department", "federal_comments_year"]
            },
            "page": this.currentPage,
            "filters": {
              "page": {
                "type": [],
                "federal_legislation_issue": args.has('federal_legislation_issue') ? args.get('federal_legislation_issue').split(',') : [],
                "federal_department": args.has('federal_department') ? args.get('federal_department').split(',') : [],
                "federal_comments_year": args.has('federal_comments_year') ? args.get('federal_comments_year').split(',') : [],
              }
            },
          }
        } else {
          data = {
            "q": this.searchTerm,
            "per_page": this.perPage,
            "facets": {
              "page": ["type", "federal_legislation_issue", "federal_department", "federal_comments_year"]
            },
            "page": this.currentPage,
            "filters": {
              "page": {
                "type": [],
                "federal_legislation_issue": this.getActiveFiltersByKind('federal_legislation_issue'),
                "federal_department": this.getActiveFiltersByKind('federal_department'),
                "federal_comments_year": this.getActiveFiltersByKind('federal_comments_year'),
              }
            },
          }
        }
        return data
      },
      getParameter(filter_kind, filter_value) {
        let filters = {}
        if (filter_kind === "group_one") {
          filters = this.allGroupOneFilters
        } else {
          return filter_kind
        }
        for (const [index, filter] of Object.entries(filters)) {
          if (filter.kind === filter_kind && filter.value === filter_value) {
            return filter.parameter
          }
        }
      },
    },
    data() {
      return {
        api: `https://search-api.swiftype.com/api/v1/public/engines/search.json?engine_key=${engineKey}`,
        featured_nodes: null,
        ra_year: null,
        search_settings: searchSettings,
        headers: {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Access-Control-Allow-Origin': '*',
            'Accept': 'application/json'
          }
        },
        additional_parameters_string: '',
      }
    },
    mounted() {
      this.$store.commit('updateAllIssueFilters', issueFilters)
      this.$store.commit('updateAllTypeFilters', typeFilters)
      this.$store.commit('updateAllGroupOneFilters', {...articleTypeFilters, ...resourceTypeFilters})
      this.$store.commit('updateAllArticleTypeFilters', articleTypeFilters)
      this.$store.commit('updateAllResourceTypeFilters', resourceTypeFilters)
      this.$store.commit('updateAllCampaignFilters', campaignFilters)
      this.$store.commit('updateAllProfessionalPracticeFilters', professionalPracticeFilters)
      this.$store.commit('updateAllFormatFilters', formatFilters)
      this.$store.commit('updateAllAcademicSubjectFilters', academicSubjectFilters)
      this.$store.commit('updateAllGradeLevelFilters', gradeLevelFilters)
      this.$store.commit('updateAllRoleFilters', roleFilters)
      this.$store.commit('updateAllYearFilters', yearFilters)
      this.$store.commit('updateAllStateFilters', stateFilters)
      if(!this.isNEATodayNewsAndArticles) {
        this.$store.commit('updateAllNEATodayFilters', neaTodayFilters)
      }
      this.$store.commit('updateAllThemeFilters', themeFilters)
      this.$store.commit('updateAllReadingLevelFilters', readingLevelFilters)
      this.$store.commit('updateAllGenreFilters', genreFilters)

      this.$store.commit('updateAllActionTypeFilters', actionTypeFilters)
      this.$store.commit('updateAllCongressFilters', congressFilters)
      this.$store.commit('updateAllPositionFilters', positionFilters)
      this.$store.commit('updateAllChamberFilters', chamberFilters)
      this.$store.commit('updateAllFederalDepartmentFilters', federalDepartmentFilters)
      this.$store.commit('updateAllFederalCommentsYearFilters', federalCommentsYearFilters)
      this.$store.commit('updateAllQuickActionFilters', quickActionFilters)
      this.$store.commit('updateAllFederalLegislationIssueFilters', federalLegislationIssueFilters)

      this.$store.commit('updateAllNEATodaySectionFilters', neaTodaySectionFilters)

      this.$store.commit('updateRaYear', raYear)

      if(this.isTakeAction || this.isEdJusticeTakeAction) {
        this.$store.commit('updatePerPage', 12)
      }
      this.query()
      this.featured_nodes = featuredNodes
    },
  }

</script>
